import { createSelector } from '@reduxjs/toolkit';
import { INTERNATIONAL_SUPPORT } from '@rsos/capstone/src/constants/capabilities';

/**
 * Determines if the current agency has the `INTERNATIONAL_SUPPORT` capability enabled.
 * @param {Object} state - redux state
 * @param {Object} state.psaps - PSAPS reducer
 * @param {Object} state.sinatra - Sinatra reducer
 */
const checkInternationalSupport = createSelector(
  state => state,
  state => {
    const isCapabilityEnabled =
      !!state.psaps?.currentPSAP?.activeCapabilities?.[INTERNATIONAL_SUPPORT];

    return isCapabilityEnabled;
  },
);

export default checkInternationalSupport;
